import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const MeisaiKbn = props => {
  return <Dropdown.Static kubunKey='meisai_kbn' {...props} />
}
